// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Enterprise Dashboard — luxury SaaS design system */

.premium-dashboard {
  --pd-max: 1600px;
  --pd-gap: 24px;
  --pd-section: 32px;
  --pd-card-pad: 24px;
  --pd-radius: 20px;
  --pd-blue: #2563eb;
  --pd-blue-soft: rgba(37, 99, 235, 0.08);
  --pd-blue-glow: rgba(37, 99, 235, 0.25);
  --pd-surface: rgba(255, 255, 255, 0.92);
  --pd-glass: rgba(255, 255, 255, 0.75);
  --pd-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);
  --pd-shadow-hover: 0 12px 40px rgba(15, 23, 42, 0.1);
  --pd-text: #0f172a;
  --pd-muted: #64748b;
  --pd-border: rgba(226, 232, 240, 0.8);
  max-width: var(--pd-max);
  margin: 0 auto;
  padding: 32px;
  animation: pdFadeIn 0.5s ease;
}

@keyframes pdFadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.premium-dashboard__header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--pd-gap);
  margin-bottom: var(--pd-section);
}

.premium-dashboard__greeting {
  font-size: 28px;
  font-weight: 700;
  color: var(--pd-text);
  margin: 0 0 4px;
  letter-spacing: -0.02em;
}

.premium-dashboard__subtitle {
  font-size: 14px;
  color: var(--pd-muted);
  margin: 0;
}

.premium-dashboard__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  font-size: 12px;
  color: var(--pd-muted);
}

.premium-dashboard__meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--pd-blue-soft);
  border-radius: 999px;
}

.premium-dashboard__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.pd-filter-pill {
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid var(--pd-border);
  background: var(--pd-surface);
  font-size: 12px;
  font-weight: 500;
  color: var(--pd-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.pd-filter-pill:hover,
.pd-filter-pill--active {
  background: var(--pd-blue);
  color: #fff;
  border-color: var(--pd-blue);
  box-shadow: 0 4px 12px var(--pd-blue-glow);
}

.pd-grid {
  display: grid;
  gap: var(--pd-gap);
}

.pd-grid--12 {
  grid-template-columns: repeat(12, 1fr);
}

.pd-col-3 { grid-column: span 3; }
.pd-col-4 { grid-column: span 4; }
.pd-col-6 { grid-column: span 6; }
.pd-col-8 { grid-column: span 8; }
.pd-col-9 { grid-column: span 9; }
.pd-col-12 { grid-column: span 12; }

@media (max-width: 1200px) {
  .pd-col-3, .pd-col-4 { grid-column: span 6; }
  .pd-col-8, .pd-col-9 { grid-column: span 12; }
}

@media (max-width: 768px) {
  .premium-dashboard { padding: 16px; }
  .pd-col-3, .pd-col-4, .pd-col-6 { grid-column: span 12; }
}

.pd-card {
  background: var(--pd-surface);
  backdrop-filter: blur(12px);
  border-radius: var(--pd-radius);
  padding: var(--pd-card-pad);
  box-shadow: var(--pd-shadow);
  border: 1px solid var(--pd-border);
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.pd-card:hover {
  transform: scale(1.01);
  box-shadow: var(--pd-shadow-hover);
}

.pd-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
}

.pd-card__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--pd-text);
  margin: 0;
}

.pd-card__extra {
  font-size: 11px;
  color: var(--pd-muted);
}

.pd-kpi {
  position: relative;
  overflow: hidden;
}

.pd-kpi::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--pd-accent, var(--pd-blue)), transparent);
  border-radius: var(--pd-radius) var(--pd-radius) 0 0;
}

.pd-kpi__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.pd-kpi__icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--pd-blue-soft);
  color: var(--pd-accent, var(--pd-blue));
}

.pd-kpi__label {
  font-size: 12px;
  font-weight: 500;
  color: var(--pd-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
}

.pd-kpi__value {
  font-size: 24px;
  font-weight: 700;
  color: var(--pd-text);
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.pd-kpi__trend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  margin-top: 6px;
  font-weight: 500;
}

.pd-kpi__trend--up { color: #16a34a; }
.pd-kpi__trend--down { color: #dc2626; }
.pd-kpi__trend--neutral { color: var(--pd-muted); }

.pd-kpi__spark {
  height: 36px;
  margin-top: 12px;
  opacity: 0.85;
}

.pd-kpi__updated {
  font-size: 10px;
  color: var(--pd-muted);
  margin-top: 8px;
}

.pd-quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: var(--pd-section);
}

.pd-quick-action {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid var(--pd-border);
  background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.pd-quick-action:hover {
  border-color: var(--pd-blue);
  box-shadow: 0 8px 24px var(--pd-blue-glow);
  transform: translateY(-2px);
}

.pd-quick-action__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--pd-blue-soft);
  color: var(--pd-blue);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pd-quick-action__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--pd-text);
}

.pd-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pd-timeline__item {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--pd-border);
}

.pd-timeline__item:last-child { border-bottom: none; }

.pd-timeline__icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: var(--pd-blue-soft);
  color: var(--pd-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pd-timeline__body { flex: 1; min-width: 0; }
.pd-timeline__title { font-size: 13px; font-weight: 500; color: var(--pd-text); }
.pd-timeline__meta { font-size: 11px; color: var(--pd-muted); margin-top: 2px; }

.pd-sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--pd-gap);
}

.pd-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 13px;
}

.pd-stat-row__label { color: var(--pd-muted); }
.pd-stat-row__value { font-weight: 600; color: var(--pd-text); }

.pd-table .ant-table {
  background: transparent !important;
}

.pd-table .ant-table-thead > tr > th {
  background: #f8fafc !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--pd-muted) !important;
  border-bottom: 1px solid var(--pd-border) !important;
}

.pd-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--pd-border) !important;
  font-size: 13px;
}

.pd-table .ant-table-tbody > tr:hover > td {
  background: var(--pd-blue-soft) !important;
}

.pd-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: var(--pd-gap);
  align-items: start;
}

@media (max-width: 1100px) {
  .pd-layout { grid-template-columns: 1fr; }
}

.pd-skeleton {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: pdShimmer 1.2s infinite;
  border-radius: 12px;
  min-height: 120px;
}

@keyframes pdShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.pd-fbr-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.pd-fbr-status--on { background: #dcfce7; color: #166534; }
.pd-fbr-status--off { background: #fef3c7; color: #92400e; }

.pd-progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 4px;
}

.pd-empty {
  text-align: center;
  padding: 32px 16px;
  color: var(--pd-muted);
  font-size: 13px;
}

/* ─── V2 Layout (reference design) ─── */

.premium-dashboard--v2 {
  padding: 20px 24px 32px;
  background: #f1f5f9;
  max-width: none;
  width: 100%;
  margin: 0;
  min-height: 100%;
  box-sizing: border-box;
}

.pd-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.pd-toolbar__left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.pd-toolbar__date {
  font-size: 13px;
  color: var(--pd-muted);
  margin-left: 8px;
}

.pd-toolbar__refresh {
  color: var(--pd-muted) !important;
}

.pd-hero {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.pd-hero .premium-dashboard__greeting {
  font-size: 26px;
  margin-bottom: 2px;
}

.pd-hero .premium-dashboard__subtitle {
  font-size: 14px;
}

/* Quick action bar */
.pd-quick-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.pd-quick-bar__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1.5px solid transparent;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.pd-quick-bar__btn--primary {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
}

.pd-quick-bar__btn--primary:hover {
  background: #1d4ed8;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
}

.pd-quick-bar__btn--green {
  background: #fff;
  color: #16a34a;
  border-color: #bbf7d0;
}

.pd-quick-bar__btn--green:hover { background: #f0fdf4; }

.pd-quick-bar__btn--orange {
  background: #fff;
  color: #ea580c;
  border-color: #fed7aa;
}

.pd-quick-bar__btn--orange:hover { background: #fff7ed; }

.pd-quick-bar__btn--purple {
  background: #fff;
  color: #7c3aed;
  border-color: #ddd6fe;
}

.pd-quick-bar__btn--purple:hover { background: #f5f3ff; }

.pd-quick-bar__btn--muted {
  background: #fff;
  color: var(--pd-muted);
  border-color: var(--pd-border);
}

.pd-quick-bar__btn--muted:hover { background: #f8fafc; }

/* KPI full-width grid — auto columns */
.pd-kpi-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.pd-kpi-row--extended {
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
}

@media (max-width: 1400px) {
  .pd-kpi-row { grid-template-columns: repeat(4, 1fr); }
}

@media (max-width: 900px) {
  .pd-kpi-row { grid-template-columns: repeat(2, 1fr); }
}

.pd-kpi--compact {
  padding: 16px;
}

.pd-kpi--compact:hover {
  transform: translateY(-2px);
  scale: 1;
}

.pd-kpi__main {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.pd-kpi__icon--sm {
  width: 36px !important;
  height: 36px !important;
  border-radius: 10px !important;
  flex-shrink: 0;
}

.pd-kpi--compact .pd-kpi__value {
  font-size: 20px;
}

.pd-kpi__spark--sm {
  height: 28px;
  margin-top: 8px;
}

/* Charts row */
.pd-charts-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr 0.75fr;
  gap: 16px;
  margin-bottom: 24px;
  align-items: stretch;
}

@media (max-width: 1200px) {
  .pd-charts-row { grid-template-columns: 1fr; }
}

.pd-card--chart-main {
  min-height: 320px;
}

.pd-segment {
  display: flex;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
}

.pd-segment__btn {
  padding: 4px 10px;
  border: none;
  background: transparent;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--pd-muted);
  cursor: pointer;
  transition: all 0.15s;
}

.pd-segment__btn--active {
  background: #fff;
  color: var(--pd-text);
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

/* Payment legend */
.pd-pay-legend {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pd-pay-legend__item {
  display: grid;
  grid-template-columns: 10px 1fr auto auto;
  gap: 8px;
  align-items: center;
  padding: 5px 0;
  font-size: 12px;
}

.pd-pay-legend__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.pd-pay-legend__name { color: var(--pd-text); font-weight: 500; }
.pd-pay-legend__pct { color: var(--pd-muted); font-size: 11px; }
.pd-pay-legend__amt { font-weight: 600; color: var(--pd-text); font-size: 11px; }

/* Cash flow */
.pd-cashflow__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;
  font-size: 13px;
  color: var(--pd-muted);
  border-bottom: 1px solid #f1f5f9;
}

.pd-cashflow__row:last-child { border-bottom: none; }

.pd-cashflow__row--highlight {
  background: #f8fafc;
  margin: 4px -12px;
  padding: 9px 12px;
  border-radius: 8px;
  border-bottom: none;
}

.pd-cashflow__val {
  font-weight: 700;
  color: var(--pd-text);
}

.pd-cashflow__val--green { color: #16a34a; }
.pd-cashflow__val--red { color: #dc2626; }

/* Middle row */
.pd-mid-row {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 16px;
  margin-bottom: 24px;
  align-items: start;
}

@media (max-width: 1100px) {
  .pd-mid-row { grid-template-columns: 1fr; }
}

.pd-mid-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pd-card--sales .ant-table-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.pd-invoice-link {
  color: #2563eb;
  font-weight: 600;
  font-size: 12px;
}

.pd-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: none;
  border: none;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.pd-link-btn:hover { text-decoration: underline; }

/* Tags */
.pd-tag {
  border: none !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.03em;
  border-radius: 6px !important;
  margin: 0 !important;
}

.pd-tag--cash { background: #dcfce7 !important; color: #166534 !important; }
.pd-tag--credit { background: #fef3c7 !important; color: #92400e !important; }
.pd-tag--bank { background: #dbeafe !important; color: #1e40af !important; }
.pd-tag--card { background: #ede9fe !important; color: #5b21b6 !important; }
.pd-tag--done { background: #dcfce7 !important; color: #166534 !important; }

/* Timeline compact */
.pd-timeline--compact .pd-timeline__item {
  padding: 8px 0;
}

.pd-timeline--compact .pd-timeline__icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

/* Inventory summary */
.pd-inv-summary__row {
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  font-size: 13px;
  color: var(--pd-muted);
  border-bottom: 1px solid #f1f5f9;
}

.pd-inv-summary__row:last-child { border-bottom: none; }

.pd-inv-summary__row strong {
  color: var(--pd-text);
  font-weight: 700;
}

.pd-inv-summary__warn { color: #f59e0b !important; }
.pd-inv-summary__danger { color: #dc2626 !important; }

/* FBR */
.pd-fbr-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.pd-fbr-status--on .pd-fbr-dot { background: #16a34a; }

.pd-fbr-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.pd-fbr-stats div {
  text-align: center;
  padding: 8px;
  background: #f8fafc;
  border-radius: 8px;
}

.pd-fbr-stats span {
  display: block;
  font-size: 10px;
  color: var(--pd-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pd-fbr-stats strong {
  font-size: 18px;
  font-weight: 700;
  color: var(--pd-text);
}

/* Bottom row */
.pd-bottom-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.pd-bottom-row--wide {
  grid-template-columns: repeat(3, 1fr);
}

.pd-full-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 1200px) {
  .pd-bottom-row,
  .pd-bottom-row--wide { grid-template-columns: repeat(2, 1fr); }
  .pd-full-row { grid-template-columns: 1fr; }
}

@media (max-width: 640px) {
  .pd-bottom-row,
  .pd-bottom-row--wide { grid-template-columns: 1fr; }
  .premium-dashboard--v2 { padding: 12px; }
}

/* Business summary strip */
.pd-summary-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px 18px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid var(--pd-border);
  box-shadow: var(--pd-shadow);
}

.pd-summary-strip__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 20px;
  border-right: 1px solid #f1f5f9;
  min-width: 100px;
}

.pd-summary-strip__item:last-child { border-right: none; }

.pd-summary-strip__label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--pd-muted);
}

.pd-summary-strip__val {
  font-size: 15px;
  font-weight: 700;
  color: var(--pd-text);
}

.pd-customers-table .ant-table { font-size: 12px; }

.pd-rank-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pd-rank-list__item {
  display: grid;
  grid-template-columns: 20px 1fr auto auto;
  gap: 8px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.pd-rank-list__item:last-child { border-bottom: none; }

.pd-rank-list__rank {
  font-size: 11px;
  font-weight: 700;
  color: var(--pd-muted);
}

.pd-rank-list__name {
  font-weight: 500;
  color: var(--pd-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pd-rank-list__meta {
  font-size: 11px;
  color: var(--pd-muted);
}

.pd-rank-list__val {
  font-weight: 700;
  color: var(--pd-text);
  font-size: 12px;
}

.pd-rank-list__danger {
  color: #dc2626;
  font-weight: 700;
  font-size: 12px;
}

.pd-rank-list__item--alert {
  grid-template-columns: 1fr auto;
}

.pd-empty--ok { color: #16a34a; }

/* Reduce hover scale on v2 cards */
.premium-dashboard--v2 .pd-card:hover {
  transform: translateY(-1px);
}

/* ─── POS Dashboard (clean layout) ─── */

.pos-dashboard {
  width: 100%;
  min-height: 100%;
  padding: 20px 24px 32px;
  background: #f1f5f9;
  box-sizing: border-box;
}

.pos-dashboard__header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.pos-dashboard__header h1 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 2px;
  color: #0f172a;
}

.pos-dashboard__header p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.pos-dashboard__header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pos-dashboard .pd-quick-bar {
  margin-bottom: 20px;
}

.pos-dashboard__kpis {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

@media (max-width: 1400px) {
  .pos-dashboard__kpis { grid-template-columns: repeat(4, 1fr); }
}

@media (max-width: 640px) {
  .pos-dashboard__kpis { grid-template-columns: repeat(2, 1fr); }
  .pos-dashboard { padding: 12px; }
}

.pos-dashboard__strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  margin-bottom: 16px;
  font-size: 12px;
  color: #64748b;
}

.pos-dashboard__strip strong {
  color: #0f172a;
  margin-left: 4px;
}

.pos-dashboard__charts {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 1100px) {
  .pos-dashboard__charts { grid-template-columns: 1fr; }
}

.pos-dashboard__main {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  align-items: start;
}

@media (max-width: 1000px) {
  .pos-dashboard__main { grid-template-columns: 1fr; }
}

.pos-dashboard__side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pos-dashboard .pd-card:hover {
  transform: translateY(-1px);
}

/* ─── Reference Dashboard (db-page) ─── */

.db-page {
  width: 100%;
  min-height: 100%;
  padding: 16px 20px 28px;
  background: #f4f6f9;
  box-sizing: border-box;
}

.db-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.db-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px 12px;
  color: #94a3b8;
}

.db-search input {
  background: transparent !important;
  box-shadow: none !important;
}

.db-kbd {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #94a3b8;
  border: 1px solid #e2e8f0;
}

.db-toolbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.db-branch, .db-date {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #334155;
}

.db-spin { animation: dbSpin 0.8s linear infinite; }
@keyframes dbSpin { to { transform: rotate(360deg); } }

.db-hero {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.db-hero h1 {
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #0f172a;
}

.db-hero p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.db-sync {
  color: #22c55e;
  font-weight: 500;
}

.db-kpis {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

@media (max-width: 1300px) { .db-kpis { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 640px) { .db-kpis { grid-template-columns: repeat(2, 1fr); } .db-page { padding: 12px; } }

.db-mid {
  display: grid;
  grid-template-columns: 1.6fr 1fr 0.85fr;
  gap: 16px;
  margin-bottom: 16px;
  align-items: stretch;
}

@media (max-width: 1100px) { .db-mid { grid-template-columns: 1fr; } }

.db-chart-card { min-height: 320px; }

.db-chart-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.db-mid-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.db-donut-wrap {
  position: relative;
}

.db-donut-center {
  position: absolute;
  top: 55px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  pointer-events: none;
}

.db-donut-center span {
  display: block;
  font-size: 10px;
  color: #94a3b8;
}

.db-donut-center strong {
  font-size: 14px;
  color: #0f172a;
}

.db-gauge {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.db-gauge__label {
  font-size: 11px;
  color: #64748b;
}

.db-lower {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 1000px) { .db-lower { grid-template-columns: 1fr; } }

.db-lower-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.db-bottom {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 1100px) { .db-bottom { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .db-bottom { grid-template-columns: 1fr; } }

.db-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
}

.db-status--ok { color: #16a34a; }

.db-fbr-score {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 10px;
}

.db-fbr-score strong { color: #16a34a; }

.db-fbr-score__hint {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.db-page--luxury .pd-kpi__value {
  font-variant-numeric: tabular-nums;
  font-feature-settings: normal;
}

.db-page .pd-card {
  background: #fff;
  border: 1px solid #e8ecf1;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.db-page .pd-card:hover {
  transform: translateY(-1px);
  scale: 1;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

.pd-rank-list__item--alert {
  grid-template-columns: 20px 1fr auto;
}

/* ─── Luxury Dashboard (db-page--luxury) ─── */

.db-page--luxury {
  --db-bg: #eef1f6;
  --db-surface: #ffffff;
  --db-text: #0b1220;
  --db-muted: #64748b;
  --db-border: rgba(226, 232, 240, 0.95);
  --db-radius: 18px;
  --db-radius-sm: 12px;
  --db-gap: 20px;
  --db-section-gap: 28px;
  --db-pad-x: 32px;
  --db-pad-y: 28px;
  --db-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.04);
  --db-shadow-hover: 0 4px 8px rgba(15, 23, 42, 0.04), 0 16px 40px rgba(15, 23, 42, 0.08);
  max-width: 1680px;
  margin: 0 auto;
  padding: var(--db-pad-y) var(--db-pad-x) 40px;
  background:
    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(37, 99, 235, 0.06), transparent),
    linear-gradient(180deg, #f8fafc 0%, var(--db-bg) 100%);
  font-feature-settings: normal;
  -webkit-font-smoothing: antialiased;
}

.db-page--luxury .db-toolbar {
  margin-bottom: var(--db-section-gap);
  padding: 4px 0;
}

.db-page--luxury .db-search {
  max-width: 460px;
  padding: 6px 14px;
  border-radius: var(--db-radius-sm);
  border-color: var(--db-border);
  box-shadow: var(--db-shadow);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.db-page--luxury .db-search:focus-within {
  border-color: rgba(37, 99, 235, 0.35);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08), var(--db-shadow);
}

.db-page--luxury .db-search input {
  font-size: 14px !important;
  color: var(--db-text) !important;
}

.db-page--luxury .db-branch,
.db-page--luxury .db-date {
  padding: 8px 14px;
  border-radius: var(--db-radius-sm);
  border-color: var(--db-border);
  box-shadow: var(--db-shadow);
  font-weight: 500;
  letter-spacing: -0.01em;
}

.db-page--luxury .db-hero {
  margin-bottom: var(--db-section-gap);
  align-items: flex-end;
}

.db-page--luxury .db-hero__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--db-muted);
}

.db-page--luxury .db-hero h1 {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--db-text);
  margin: 0 0 8px;
}

.db-page--luxury .db-hero__sub {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: var(--db-muted);
  max-width: 520px;
}

.db-page--luxury .db-sync {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.1);
  color: #15803d;
  font-size: 12px;
  font-weight: 600;
}

.db-page--luxury .db-section {
  margin-bottom: var(--db-section-gap);
}

.db-page--luxury .db-section--last {
  margin-bottom: 0;
}

.db-page--luxury .db-section__head {
  margin-bottom: 14px;
}

.db-page--luxury .db-section__head h2 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--db-muted);
}

.db-page--luxury .db-kpis--primary {
  grid-template-columns: repeat(6, 1fr);
  gap: var(--db-gap);
  margin-bottom: 0;
}

.db-page--luxury .db-kpis--secondary {
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 0;
}

@media (max-width: 1400px) {
  .db-page--luxury .db-kpis--primary { grid-template-columns: repeat(3, 1fr); }
  .db-page--luxury .db-kpis--secondary { grid-template-columns: repeat(4, 1fr); }
}

@media (max-width: 900px) {
  .db-page--luxury .db-kpis--primary,
  .db-page--luxury .db-kpis--secondary { grid-template-columns: repeat(2, 1fr); }
  .db-page--luxury { padding: 20px 16px 32px; }
}

@media (max-width: 575px) {
  .db-page--luxury .db-kpis--primary,
  .db-page--luxury .db-kpis--secondary,
  .pd-kpi-row,
  .pos-dashboard__kpis,
  .db-kpis {
    grid-template-columns: 1fr;
  }

  .db-page--luxury {
    padding: 14px 12px 24px;
  }

  .db-page--luxury .pd-card,
  .db-page--luxury .db-card {
    padding: 14px;
  }

  .db-toolbar__right,
  .pos-dashboard__header-right,
  .db-page--luxury .db-toolbar {
    flex-wrap: wrap;
    gap: 8px;
  }

  .db-page--luxury .db-summary-strip__item {
    flex: 1 1 100%;
  }
}

.db-page--luxury .db-summary-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin-bottom: var(--db-section-gap);
  padding: 0;
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-radius: var(--db-radius);
  box-shadow: var(--db-shadow);
  overflow: hidden;
}

.db-page--luxury .db-summary-strip__item {
  flex: 1 1 140px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 20px;
  border-right: 1px solid #f1f5f9;
  min-width: 0;
}

.db-page--luxury .db-summary-strip__item:last-child {
  border-right: none;
}

.db-page--luxury .db-summary-strip__item--shift {
  background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%);
}

.db-page--luxury .db-summary-strip__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--db-muted);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.db-page--luxury .db-summary-strip__val {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--db-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.db-page--luxury .db-summary-strip__val--live {
  color: #15803d;
}

.db-page--luxury .pd-card {
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-radius: var(--db-radius);
  padding: 22px 24px;
  box-shadow: var(--db-shadow);
  backdrop-filter: none;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.db-page--luxury .pd-card:hover {
  transform: translateY(-2px);
  scale: 1;
  box-shadow: var(--db-shadow-hover);
}

.db-page--luxury .pd-card__title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.db-page--luxury .pd-kpi--compact {
  padding: 18px 20px;
}

.db-page--luxury .pd-kpi__label {
  font-size: 11px;
  letter-spacing: 0.05em;
}

.db-page--luxury .pd-kpi__value {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.db-page--luxury .pd-kpi--compact .pd-kpi__value {
  font-size: 19px;
}

.db-page--luxury .db-kpis--secondary .pd-kpi__value {
  font-size: 17px;
}

.db-page--luxury .db-kpis--secondary .pd-kpi__spark {
  display: none;
}

.db-page--luxury .db-mid,
.db-page--luxury .db-lower,
.db-page--luxury .db-bottom {
  gap: var(--db-gap);
}

.db-page--luxury .db-chart-card {
  min-height: 340px;
}

.db-page--luxury .pd-segment {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
}

.db-page--luxury .pd-segment__btn {
  padding: 5px 12px;
  font-size: 12px;
  border-radius: 8px;
}

.db-page--luxury .pd-cashflow__row {
  padding: 10px 0;
  font-size: 13px;
}

.db-page--luxury .pd-inv-summary__row {
  padding: 9px 0;
  font-size: 13px;
}

.db-page--luxury .pd-table .ant-table-thead > tr > th {
  font-size: 10px !important;
  letter-spacing: 0.06em;
  padding: 10px 12px !important;
}

.db-page--luxury .pd-table .ant-table-tbody > tr > td {
  padding: 11px 12px !important;
  font-size: 13px;
}

.db-page--luxury .pd-timeline__title {
  font-size: 13px;
  font-weight: 600;
}

.db-page--luxury .pd-rank-list__item {
  padding: 10px 0;
}

.db-page--luxury .pd-quick-bar__btn {
  padding: 9px 18px;
  border-radius: var(--db-radius-sm);
  font-size: 13px;
  letter-spacing: -0.01em;
}

.db-page--luxury .db-lower-side .pd-card {
  flex: 1;
}

.db-page--luxury .pd-kpi--clickable {
  cursor: pointer;
}

.db-page--luxury .pd-kpi--clickable:hover {
  border-color: rgba(37, 99, 235, 0.25);
}

.db-status--warn { color: #d97706; }
.db-status--bad { color: #dc2626; }
`, "",{"version":3,"sources":["webpack://./src/styles/dashboard-premium.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,8CAA8C;EAC9C,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;AACjC,YAAY,mBAAmB,EAAE;AACjC,aAAa,oBAAoB,EAAE;;AAEnC;EACE,uBAAuB,mBAAmB,EAAE;EAC5C,uBAAuB,oBAAoB,EAAE;AAC/C;;AAEA;EACE,qBAAqB,aAAa,EAAE;EACpC,kCAAkC,oBAAoB,EAAE;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iFAAiF;EACjF,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB,cAAc,EAAE;AACrC,uBAAuB,cAAc,EAAE;AACvC,0BAA0B,sBAAsB,EAAE;;AAElD;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0DAA0D;EAC1D,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA,gCAAgC,mBAAmB,EAAE;;AAErD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,qBAAqB,OAAO,EAAE,YAAY,EAAE;AAC5C,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAChF,qBAAqB,eAAe,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB,sBAAsB,EAAE;AAC9C,sBAAsB,gBAAgB,EAAE,qBAAqB,EAAE;;AAE/D;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa,0BAA0B,EAAE;AAC3C;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yCAAyC;;AAEzC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,kCAAkC,mBAAmB,EAAE;;AAEvD;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,kCAAkC,mBAAmB,EAAE;;AAEvD,uCAAuC;AACvC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,cAAc,qCAAqC,EAAE;AACvD;;AAEA;EACE,cAAc,qCAAqC,EAAE;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,uBAAuB,qBAAqB,EAAE,gBAAgB,EAAE;AAChE,sBAAsB,sBAAsB,EAAE,eAAe,EAAE;AAC/D,sBAAsB,gBAAgB,EAAE,qBAAqB,EAAE,eAAe,EAAE;;AAEhF,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,yBAAyB,cAAc,EAAE;;AAEzC,eAAe;AACf;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc,0BAA0B,EAAE;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA,qBAAqB,0BAA0B,EAAE;;AAEjD,SAAS;AACT;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,gBAAgB,8BAA8B,EAAE,yBAAyB,EAAE;AAC3E,kBAAkB,8BAA8B,EAAE,yBAAyB,EAAE;AAC7E,gBAAgB,8BAA8B,EAAE,yBAAyB,EAAE;AAC3E,gBAAgB,8BAA8B,EAAE,yBAAyB,EAAE;AAC3E,gBAAgB,8BAA8B,EAAE,yBAAyB,EAAE;;AAE3E,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kCAAkC,mBAAmB,EAAE;;AAEvD;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wBAAwB,yBAAyB,EAAE;AACnD,0BAA0B,yBAAyB,EAAE;;AAErD,QAAQ;AACR;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;yBACuB,qCAAqC,EAAE;EAC9D,eAAe,0BAA0B,EAAE;AAC7C;;AAEA;EACE;yBACuB,0BAA0B,EAAE;EACnD,yBAAyB,aAAa,EAAE;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,qCAAqC,kBAAkB,EAAE;;AAEzD;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iCAAiC,eAAe,EAAE;;AAElD;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gBAAgB,cAAc,EAAE;;AAEhC,mCAAmC;AACnC;EACE,2BAA2B;AAC7B;;AAEA,yCAAyC;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB,qCAAqC,EAAE;AAChE;;AAEA;EACE,uBAAuB,qCAAqC,EAAE;EAC9D,iBAAiB,aAAa,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,0BAA0B,EAAE;AACvD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB,0BAA0B,EAAE;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0CAA0C;;AAE1C;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW,sCAAsC,EAAE;AACnD,oBAAoB,KAAK,yBAAyB,EAAE,EAAE;;AAEtD;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B,WAAW,qCAAqC,EAAE,EAAE;AACjF,4BAA4B,WAAW,qCAAqC,EAAE,EAAE,WAAW,aAAa,EAAE,EAAE;;AAE5G;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,6BAA6B,UAAU,0BAA0B,EAAE,EAAE;;AAErE,iBAAiB,iBAAiB,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B,YAAY,0BAA0B,EAAE,EAAE;;AAEvE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,6BAA6B,aAAa,qCAAqC,EAAE,EAAE;AACnF,4BAA4B,aAAa,0BAA0B,EAAE,EAAE;;AAEvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB,cAAc,EAAE;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB,cAAc,EAAE;;AAEvC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;EACR,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gFAAgF;EAChF,uFAAuF;EACvF,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C;;0DAEwD;EACxD,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,+DAA+D;AACjE;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC,qCAAqC,EAAE;EAC5E,uCAAuC,qCAAqC,EAAE;AAChF;;AAEA;EACE;yCACuC,qCAAqC,EAAE;EAC9E,mBAAmB,uBAAuB,EAAE;AAC9C;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;;IAGE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,oCAAoC;EACpC,UAAU;EACV,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB,cAAc,EAAE;AACnC,kBAAkB,cAAc,EAAE","sourcesContent":["/* Premium Enterprise Dashboard — luxury SaaS design system */\n\n.premium-dashboard {\n  --pd-max: 1600px;\n  --pd-gap: 24px;\n  --pd-section: 32px;\n  --pd-card-pad: 24px;\n  --pd-radius: 20px;\n  --pd-blue: #2563eb;\n  --pd-blue-soft: rgba(37, 99, 235, 0.08);\n  --pd-blue-glow: rgba(37, 99, 235, 0.25);\n  --pd-surface: rgba(255, 255, 255, 0.92);\n  --pd-glass: rgba(255, 255, 255, 0.75);\n  --pd-shadow: 0 4px 24px rgba(15, 23, 42, 0.06);\n  --pd-shadow-hover: 0 12px 40px rgba(15, 23, 42, 0.1);\n  --pd-text: #0f172a;\n  --pd-muted: #64748b;\n  --pd-border: rgba(226, 232, 240, 0.8);\n  max-width: var(--pd-max);\n  margin: 0 auto;\n  padding: 32px;\n  animation: pdFadeIn 0.5s ease;\n}\n\n@keyframes pdFadeIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.premium-dashboard__header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--pd-gap);\n  margin-bottom: var(--pd-section);\n}\n\n.premium-dashboard__greeting {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--pd-text);\n  margin: 0 0 4px;\n  letter-spacing: -0.02em;\n}\n\n.premium-dashboard__subtitle {\n  font-size: 14px;\n  color: var(--pd-muted);\n  margin: 0;\n}\n\n.premium-dashboard__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 12px;\n  font-size: 12px;\n  color: var(--pd-muted);\n}\n\n.premium-dashboard__meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: var(--pd-blue-soft);\n  border-radius: 999px;\n}\n\n.premium-dashboard__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.pd-filter-pill {\n  padding: 6px 14px;\n  border-radius: 999px;\n  border: 1px solid var(--pd-border);\n  background: var(--pd-surface);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--pd-muted);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pd-filter-pill:hover,\n.pd-filter-pill--active {\n  background: var(--pd-blue);\n  color: #fff;\n  border-color: var(--pd-blue);\n  box-shadow: 0 4px 12px var(--pd-blue-glow);\n}\n\n.pd-grid {\n  display: grid;\n  gap: var(--pd-gap);\n}\n\n.pd-grid--12 {\n  grid-template-columns: repeat(12, 1fr);\n}\n\n.pd-col-3 { grid-column: span 3; }\n.pd-col-4 { grid-column: span 4; }\n.pd-col-6 { grid-column: span 6; }\n.pd-col-8 { grid-column: span 8; }\n.pd-col-9 { grid-column: span 9; }\n.pd-col-12 { grid-column: span 12; }\n\n@media (max-width: 1200px) {\n  .pd-col-3, .pd-col-4 { grid-column: span 6; }\n  .pd-col-8, .pd-col-9 { grid-column: span 12; }\n}\n\n@media (max-width: 768px) {\n  .premium-dashboard { padding: 16px; }\n  .pd-col-3, .pd-col-4, .pd-col-6 { grid-column: span 12; }\n}\n\n.pd-card {\n  background: var(--pd-surface);\n  backdrop-filter: blur(12px);\n  border-radius: var(--pd-radius);\n  padding: var(--pd-card-pad);\n  box-shadow: var(--pd-shadow);\n  border: 1px solid var(--pd-border);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.pd-card:hover {\n  transform: scale(1.01);\n  box-shadow: var(--pd-shadow-hover);\n}\n\n.pd-card__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  gap: 8px;\n}\n\n.pd-card__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--pd-text);\n  margin: 0;\n}\n\n.pd-card__extra {\n  font-size: 11px;\n  color: var(--pd-muted);\n}\n\n.pd-kpi {\n  position: relative;\n  overflow: hidden;\n}\n\n.pd-kpi::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--pd-accent, var(--pd-blue)), transparent);\n  border-radius: var(--pd-radius) var(--pd-radius) 0 0;\n}\n\n.pd-kpi__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.pd-kpi__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--pd-blue-soft);\n  color: var(--pd-accent, var(--pd-blue));\n}\n\n.pd-kpi__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--pd-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 4px;\n}\n\n.pd-kpi__value {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--pd-text);\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.pd-kpi__trend {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  margin-top: 6px;\n  font-weight: 500;\n}\n\n.pd-kpi__trend--up { color: #16a34a; }\n.pd-kpi__trend--down { color: #dc2626; }\n.pd-kpi__trend--neutral { color: var(--pd-muted); }\n\n.pd-kpi__spark {\n  height: 36px;\n  margin-top: 12px;\n  opacity: 0.85;\n}\n\n.pd-kpi__updated {\n  font-size: 10px;\n  color: var(--pd-muted);\n  margin-top: 8px;\n}\n\n.pd-quick-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n  margin-bottom: var(--pd-section);\n}\n\n.pd-quick-action {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 16px;\n  border-radius: 16px;\n  border: 1px solid var(--pd-border);\n  background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.pd-quick-action:hover {\n  border-color: var(--pd-blue);\n  box-shadow: 0 8px 24px var(--pd-blue-glow);\n  transform: translateY(-2px);\n}\n\n.pd-quick-action__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--pd-blue-soft);\n  color: var(--pd-blue);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pd-quick-action__label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--pd-text);\n}\n\n.pd-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pd-timeline__item {\n  display: flex;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--pd-border);\n}\n\n.pd-timeline__item:last-child { border-bottom: none; }\n\n.pd-timeline__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: var(--pd-blue-soft);\n  color: var(--pd-blue);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pd-timeline__body { flex: 1; min-width: 0; }\n.pd-timeline__title { font-size: 13px; font-weight: 500; color: var(--pd-text); }\n.pd-timeline__meta { font-size: 11px; color: var(--pd-muted); margin-top: 2px; }\n\n.pd-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--pd-gap);\n}\n\n.pd-stat-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  font-size: 13px;\n}\n\n.pd-stat-row__label { color: var(--pd-muted); }\n.pd-stat-row__value { font-weight: 600; color: var(--pd-text); }\n\n.pd-table .ant-table {\n  background: transparent !important;\n}\n\n.pd-table .ant-table-thead > tr > th {\n  background: #f8fafc !important;\n  font-size: 11px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--pd-muted) !important;\n  border-bottom: 1px solid var(--pd-border) !important;\n}\n\n.pd-table .ant-table-tbody > tr > td {\n  border-bottom: 1px solid var(--pd-border) !important;\n  font-size: 13px;\n}\n\n.pd-table .ant-table-tbody > tr:hover > td {\n  background: var(--pd-blue-soft) !important;\n}\n\n.pd-layout {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: var(--pd-gap);\n  align-items: start;\n}\n\n@media (max-width: 1100px) {\n  .pd-layout { grid-template-columns: 1fr; }\n}\n\n.pd-skeleton {\n  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);\n  background-size: 200% 100%;\n  animation: pdShimmer 1.2s infinite;\n  border-radius: 12px;\n  min-height: 120px;\n}\n\n@keyframes pdShimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n.pd-fbr-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pd-fbr-status--on { background: #dcfce7; color: #166534; }\n.pd-fbr-status--off { background: #fef3c7; color: #92400e; }\n\n.pd-progress-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n.pd-empty {\n  text-align: center;\n  padding: 32px 16px;\n  color: var(--pd-muted);\n  font-size: 13px;\n}\n\n/* ─── V2 Layout (reference design) ─── */\n\n.premium-dashboard--v2 {\n  padding: 20px 24px 32px;\n  background: #f1f5f9;\n  max-width: none;\n  width: 100%;\n  margin: 0;\n  min-height: 100%;\n  box-sizing: border-box;\n}\n\n.pd-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 12px;\n}\n\n.pd-toolbar__left {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.pd-toolbar__date {\n  font-size: 13px;\n  color: var(--pd-muted);\n  margin-left: 8px;\n}\n\n.pd-toolbar__refresh {\n  color: var(--pd-muted) !important;\n}\n\n.pd-hero {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.pd-hero .premium-dashboard__greeting {\n  font-size: 26px;\n  margin-bottom: 2px;\n}\n\n.pd-hero .premium-dashboard__subtitle {\n  font-size: 14px;\n}\n\n/* Quick action bar */\n.pd-quick-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.pd-quick-bar__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1.5px solid transparent;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.pd-quick-bar__btn--primary {\n  background: #2563eb;\n  color: #fff;\n  border-color: #2563eb;\n}\n\n.pd-quick-bar__btn--primary:hover {\n  background: #1d4ed8;\n  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);\n}\n\n.pd-quick-bar__btn--green {\n  background: #fff;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.pd-quick-bar__btn--green:hover { background: #f0fdf4; }\n\n.pd-quick-bar__btn--orange {\n  background: #fff;\n  color: #ea580c;\n  border-color: #fed7aa;\n}\n\n.pd-quick-bar__btn--orange:hover { background: #fff7ed; }\n\n.pd-quick-bar__btn--purple {\n  background: #fff;\n  color: #7c3aed;\n  border-color: #ddd6fe;\n}\n\n.pd-quick-bar__btn--purple:hover { background: #f5f3ff; }\n\n.pd-quick-bar__btn--muted {\n  background: #fff;\n  color: var(--pd-muted);\n  border-color: var(--pd-border);\n}\n\n.pd-quick-bar__btn--muted:hover { background: #f8fafc; }\n\n/* KPI full-width grid — auto columns */\n.pd-kpi-row {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.pd-kpi-row--extended {\n  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));\n}\n\n@media (max-width: 1400px) {\n  .pd-kpi-row { grid-template-columns: repeat(4, 1fr); }\n}\n\n@media (max-width: 900px) {\n  .pd-kpi-row { grid-template-columns: repeat(2, 1fr); }\n}\n\n.pd-kpi--compact {\n  padding: 16px;\n}\n\n.pd-kpi--compact:hover {\n  transform: translateY(-2px);\n  scale: 1;\n}\n\n.pd-kpi__main {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.pd-kpi__icon--sm {\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 10px !important;\n  flex-shrink: 0;\n}\n\n.pd-kpi--compact .pd-kpi__value {\n  font-size: 20px;\n}\n\n.pd-kpi__spark--sm {\n  height: 28px;\n  margin-top: 8px;\n}\n\n/* Charts row */\n.pd-charts-row {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr 0.75fr;\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: stretch;\n}\n\n@media (max-width: 1200px) {\n  .pd-charts-row { grid-template-columns: 1fr; }\n}\n\n.pd-card--chart-main {\n  min-height: 320px;\n}\n\n.pd-segment {\n  display: flex;\n  background: #f1f5f9;\n  border-radius: 8px;\n  padding: 2px;\n  gap: 2px;\n}\n\n.pd-segment__btn {\n  padding: 4px 10px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--pd-muted);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.pd-segment__btn--active {\n  background: #fff;\n  color: var(--pd-text);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\n}\n\n/* Payment legend */\n.pd-pay-legend {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pd-pay-legend__item {\n  display: grid;\n  grid-template-columns: 10px 1fr auto auto;\n  gap: 8px;\n  align-items: center;\n  padding: 5px 0;\n  font-size: 12px;\n}\n\n.pd-pay-legend__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.pd-pay-legend__name { color: var(--pd-text); font-weight: 500; }\n.pd-pay-legend__pct { color: var(--pd-muted); font-size: 11px; }\n.pd-pay-legend__amt { font-weight: 600; color: var(--pd-text); font-size: 11px; }\n\n/* Cash flow */\n.pd-cashflow__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 0;\n  font-size: 13px;\n  color: var(--pd-muted);\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pd-cashflow__row:last-child { border-bottom: none; }\n\n.pd-cashflow__row--highlight {\n  background: #f8fafc;\n  margin: 4px -12px;\n  padding: 9px 12px;\n  border-radius: 8px;\n  border-bottom: none;\n}\n\n.pd-cashflow__val {\n  font-weight: 700;\n  color: var(--pd-text);\n}\n\n.pd-cashflow__val--green { color: #16a34a; }\n.pd-cashflow__val--red { color: #dc2626; }\n\n/* Middle row */\n.pd-mid-row {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 16px;\n  margin-bottom: 24px;\n  align-items: start;\n}\n\n@media (max-width: 1100px) {\n  .pd-mid-row { grid-template-columns: 1fr; }\n}\n\n.pd-mid-side {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pd-card--sales .ant-table-thead > tr > th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.pd-invoice-link {\n  color: #2563eb;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.pd-link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  background: none;\n  border: none;\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.pd-link-btn:hover { text-decoration: underline; }\n\n/* Tags */\n.pd-tag {\n  border: none !important;\n  font-size: 10px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.03em;\n  border-radius: 6px !important;\n  margin: 0 !important;\n}\n\n.pd-tag--cash { background: #dcfce7 !important; color: #166534 !important; }\n.pd-tag--credit { background: #fef3c7 !important; color: #92400e !important; }\n.pd-tag--bank { background: #dbeafe !important; color: #1e40af !important; }\n.pd-tag--card { background: #ede9fe !important; color: #5b21b6 !important; }\n.pd-tag--done { background: #dcfce7 !important; color: #166534 !important; }\n\n/* Timeline compact */\n.pd-timeline--compact .pd-timeline__item {\n  padding: 8px 0;\n}\n\n.pd-timeline--compact .pd-timeline__icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n}\n\n/* Inventory summary */\n.pd-inv-summary__row {\n  display: flex;\n  justify-content: space-between;\n  padding: 7px 0;\n  font-size: 13px;\n  color: var(--pd-muted);\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.pd-inv-summary__row:last-child { border-bottom: none; }\n\n.pd-inv-summary__row strong {\n  color: var(--pd-text);\n  font-weight: 700;\n}\n\n.pd-inv-summary__warn { color: #f59e0b !important; }\n.pd-inv-summary__danger { color: #dc2626 !important; }\n\n/* FBR */\n.pd-fbr-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.pd-fbr-status--on .pd-fbr-dot { background: #16a34a; }\n\n.pd-fbr-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.pd-fbr-stats div {\n  text-align: center;\n  padding: 8px;\n  background: #f8fafc;\n  border-radius: 8px;\n}\n\n.pd-fbr-stats span {\n  display: block;\n  font-size: 10px;\n  color: var(--pd-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.pd-fbr-stats strong {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--pd-text);\n}\n\n/* Bottom row */\n.pd-bottom-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.pd-bottom-row--wide {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.pd-full-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1200px) {\n  .pd-bottom-row,\n  .pd-bottom-row--wide { grid-template-columns: repeat(2, 1fr); }\n  .pd-full-row { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 640px) {\n  .pd-bottom-row,\n  .pd-bottom-row--wide { grid-template-columns: 1fr; }\n  .premium-dashboard--v2 { padding: 12px; }\n}\n\n/* Business summary strip */\n.pd-summary-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding: 14px 18px;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid var(--pd-border);\n  box-shadow: var(--pd-shadow);\n}\n\n.pd-summary-strip__item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-right: 20px;\n  border-right: 1px solid #f1f5f9;\n  min-width: 100px;\n}\n\n.pd-summary-strip__item:last-child { border-right: none; }\n\n.pd-summary-strip__label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--pd-muted);\n}\n\n.pd-summary-strip__val {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--pd-text);\n}\n\n.pd-customers-table .ant-table { font-size: 12px; }\n\n.pd-rank-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pd-rank-list__item {\n  display: grid;\n  grid-template-columns: 20px 1fr auto auto;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n\n.pd-rank-list__item:last-child { border-bottom: none; }\n\n.pd-rank-list__rank {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--pd-muted);\n}\n\n.pd-rank-list__name {\n  font-weight: 500;\n  color: var(--pd-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pd-rank-list__meta {\n  font-size: 11px;\n  color: var(--pd-muted);\n}\n\n.pd-rank-list__val {\n  font-weight: 700;\n  color: var(--pd-text);\n  font-size: 12px;\n}\n\n.pd-rank-list__danger {\n  color: #dc2626;\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.pd-rank-list__item--alert {\n  grid-template-columns: 1fr auto;\n}\n\n.pd-empty--ok { color: #16a34a; }\n\n/* Reduce hover scale on v2 cards */\n.premium-dashboard--v2 .pd-card:hover {\n  transform: translateY(-1px);\n}\n\n/* ─── POS Dashboard (clean layout) ─── */\n\n.pos-dashboard {\n  width: 100%;\n  min-height: 100%;\n  padding: 20px 24px 32px;\n  background: #f1f5f9;\n  box-sizing: border-box;\n}\n\n.pos-dashboard__header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.pos-dashboard__header h1 {\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 2px;\n  color: #0f172a;\n}\n\n.pos-dashboard__header p {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.pos-dashboard__header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pos-dashboard .pd-quick-bar {\n  margin-bottom: 20px;\n}\n\n.pos-dashboard__kpis {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1400px) {\n  .pos-dashboard__kpis { grid-template-columns: repeat(4, 1fr); }\n}\n\n@media (max-width: 640px) {\n  .pos-dashboard__kpis { grid-template-columns: repeat(2, 1fr); }\n  .pos-dashboard { padding: 12px; }\n}\n\n.pos-dashboard__strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 20px;\n  padding: 12px 16px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 16px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.pos-dashboard__strip strong {\n  color: #0f172a;\n  margin-left: 4px;\n}\n\n.pos-dashboard__charts {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1100px) {\n  .pos-dashboard__charts { grid-template-columns: 1fr; }\n}\n\n.pos-dashboard__main {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  align-items: start;\n}\n\n@media (max-width: 1000px) {\n  .pos-dashboard__main { grid-template-columns: 1fr; }\n}\n\n.pos-dashboard__side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pos-dashboard .pd-card:hover {\n  transform: translateY(-1px);\n}\n\n/* ─── Reference Dashboard (db-page) ─── */\n\n.db-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 16px 20px 28px;\n  background: #f4f6f9;\n  box-sizing: border-box;\n}\n\n.db-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.db-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  max-width: 420px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 4px 12px;\n  color: #94a3b8;\n}\n\n.db-search input {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.db-kbd {\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  color: #94a3b8;\n  border: 1px solid #e2e8f0;\n}\n\n.db-toolbar__right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.db-branch, .db-date {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 13px;\n  color: #334155;\n}\n\n.db-spin { animation: dbSpin 0.8s linear infinite; }\n@keyframes dbSpin { to { transform: rotate(360deg); } }\n\n.db-hero {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.db-hero h1 {\n  font-size: 26px;\n  font-weight: 700;\n  margin: 0 0 4px;\n  color: #0f172a;\n}\n\n.db-hero p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.db-sync {\n  color: #22c55e;\n  font-weight: 500;\n}\n\n.db-kpis {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1300px) { .db-kpis { grid-template-columns: repeat(3, 1fr); } }\n@media (max-width: 640px) { .db-kpis { grid-template-columns: repeat(2, 1fr); } .db-page { padding: 12px; } }\n\n.db-mid {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr 0.85fr;\n  gap: 16px;\n  margin-bottom: 16px;\n  align-items: stretch;\n}\n\n@media (max-width: 1100px) { .db-mid { grid-template-columns: 1fr; } }\n\n.db-chart-card { min-height: 320px; }\n\n.db-chart-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.db-mid-side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.db-donut-wrap {\n  position: relative;\n}\n\n.db-donut-center {\n  position: absolute;\n  top: 55px;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  pointer-events: none;\n}\n\n.db-donut-center span {\n  display: block;\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.db-donut-center strong {\n  font-size: 14px;\n  color: #0f172a;\n}\n\n.db-gauge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.db-gauge__label {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.db-lower {\n  display: grid;\n  grid-template-columns: 1fr 300px;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 1000px) { .db-lower { grid-template-columns: 1fr; } }\n\n.db-lower-side {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.db-bottom {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 1100px) { .db-bottom { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 600px) { .db-bottom { grid-template-columns: 1fr; } }\n\n.db-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.db-status--ok { color: #16a34a; }\n\n.db-fbr-score {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 10px;\n}\n\n.db-fbr-score strong { color: #16a34a; }\n\n.db-fbr-score__hint {\n  font-size: 11px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.db-page--luxury .pd-kpi__value {\n  font-variant-numeric: tabular-nums;\n  font-feature-settings: normal;\n}\n\n.db-page .pd-card {\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.db-page .pd-card:hover {\n  transform: translateY(-1px);\n  scale: 1;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);\n}\n\n.pd-rank-list__item--alert {\n  grid-template-columns: 20px 1fr auto;\n}\n\n/* ─── Luxury Dashboard (db-page--luxury) ─── */\n\n.db-page--luxury {\n  --db-bg: #eef1f6;\n  --db-surface: #ffffff;\n  --db-text: #0b1220;\n  --db-muted: #64748b;\n  --db-border: rgba(226, 232, 240, 0.95);\n  --db-radius: 18px;\n  --db-radius-sm: 12px;\n  --db-gap: 20px;\n  --db-section-gap: 28px;\n  --db-pad-x: 32px;\n  --db-pad-y: 28px;\n  --db-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.04);\n  --db-shadow-hover: 0 4px 8px rgba(15, 23, 42, 0.04), 0 16px 40px rgba(15, 23, 42, 0.08);\n  max-width: 1680px;\n  margin: 0 auto;\n  padding: var(--db-pad-y) var(--db-pad-x) 40px;\n  background:\n    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(37, 99, 235, 0.06), transparent),\n    linear-gradient(180deg, #f8fafc 0%, var(--db-bg) 100%);\n  font-feature-settings: normal;\n  -webkit-font-smoothing: antialiased;\n}\n\n.db-page--luxury .db-toolbar {\n  margin-bottom: var(--db-section-gap);\n  padding: 4px 0;\n}\n\n.db-page--luxury .db-search {\n  max-width: 460px;\n  padding: 6px 14px;\n  border-radius: var(--db-radius-sm);\n  border-color: var(--db-border);\n  box-shadow: var(--db-shadow);\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.db-page--luxury .db-search:focus-within {\n  border-color: rgba(37, 99, 235, 0.35);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08), var(--db-shadow);\n}\n\n.db-page--luxury .db-search input {\n  font-size: 14px !important;\n  color: var(--db-text) !important;\n}\n\n.db-page--luxury .db-branch,\n.db-page--luxury .db-date {\n  padding: 8px 14px;\n  border-radius: var(--db-radius-sm);\n  border-color: var(--db-border);\n  box-shadow: var(--db-shadow);\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.db-page--luxury .db-hero {\n  margin-bottom: var(--db-section-gap);\n  align-items: flex-end;\n}\n\n.db-page--luxury .db-hero__eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--db-muted);\n}\n\n.db-page--luxury .db-hero h1 {\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--db-text);\n  margin: 0 0 8px;\n}\n\n.db-page--luxury .db-hero__sub {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: var(--db-muted);\n  max-width: 520px;\n}\n\n.db-page--luxury .db-sync {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: rgba(34, 197, 94, 0.1);\n  color: #15803d;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.db-page--luxury .db-section {\n  margin-bottom: var(--db-section-gap);\n}\n\n.db-page--luxury .db-section--last {\n  margin-bottom: 0;\n}\n\n.db-page--luxury .db-section__head {\n  margin-bottom: 14px;\n}\n\n.db-page--luxury .db-section__head h2 {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--db-muted);\n}\n\n.db-page--luxury .db-kpis--primary {\n  grid-template-columns: repeat(6, 1fr);\n  gap: var(--db-gap);\n  margin-bottom: 0;\n}\n\n.db-page--luxury .db-kpis--secondary {\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n  margin-bottom: 0;\n}\n\n@media (max-width: 1400px) {\n  .db-page--luxury .db-kpis--primary { grid-template-columns: repeat(3, 1fr); }\n  .db-page--luxury .db-kpis--secondary { grid-template-columns: repeat(4, 1fr); }\n}\n\n@media (max-width: 900px) {\n  .db-page--luxury .db-kpis--primary,\n  .db-page--luxury .db-kpis--secondary { grid-template-columns: repeat(2, 1fr); }\n  .db-page--luxury { padding: 20px 16px 32px; }\n}\n\n@media (max-width: 575px) {\n  .db-page--luxury .db-kpis--primary,\n  .db-page--luxury .db-kpis--secondary,\n  .pd-kpi-row,\n  .pos-dashboard__kpis,\n  .db-kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .db-page--luxury {\n    padding: 14px 12px 24px;\n  }\n\n  .db-page--luxury .pd-card,\n  .db-page--luxury .db-card {\n    padding: 14px;\n  }\n\n  .db-toolbar__right,\n  .pos-dashboard__header-right,\n  .db-page--luxury .db-toolbar {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .db-page--luxury .db-summary-strip__item {\n    flex: 1 1 100%;\n  }\n}\n\n.db-page--luxury .db-summary-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  margin-bottom: var(--db-section-gap);\n  padding: 0;\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-radius: var(--db-radius);\n  box-shadow: var(--db-shadow);\n  overflow: hidden;\n}\n\n.db-page--luxury .db-summary-strip__item {\n  flex: 1 1 140px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 20px;\n  border-right: 1px solid #f1f5f9;\n  min-width: 0;\n}\n\n.db-page--luxury .db-summary-strip__item:last-child {\n  border-right: none;\n}\n\n.db-page--luxury .db-summary-strip__item--shift {\n  background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%);\n}\n\n.db-page--luxury .db-summary-strip__label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--db-muted);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.db-page--luxury .db-summary-strip__val {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--db-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.db-page--luxury .db-summary-strip__val--live {\n  color: #15803d;\n}\n\n.db-page--luxury .pd-card {\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-radius: var(--db-radius);\n  padding: 22px 24px;\n  box-shadow: var(--db-shadow);\n  backdrop-filter: none;\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n}\n\n.db-page--luxury .pd-card:hover {\n  transform: translateY(-2px);\n  scale: 1;\n  box-shadow: var(--db-shadow-hover);\n}\n\n.db-page--luxury .pd-card__title {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.db-page--luxury .pd-kpi--compact {\n  padding: 18px 20px;\n}\n\n.db-page--luxury .pd-kpi__label {\n  font-size: 11px;\n  letter-spacing: 0.05em;\n}\n\n.db-page--luxury .pd-kpi__value {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n}\n\n.db-page--luxury .pd-kpi--compact .pd-kpi__value {\n  font-size: 19px;\n}\n\n.db-page--luxury .db-kpis--secondary .pd-kpi__value {\n  font-size: 17px;\n}\n\n.db-page--luxury .db-kpis--secondary .pd-kpi__spark {\n  display: none;\n}\n\n.db-page--luxury .db-mid,\n.db-page--luxury .db-lower,\n.db-page--luxury .db-bottom {\n  gap: var(--db-gap);\n}\n\n.db-page--luxury .db-chart-card {\n  min-height: 340px;\n}\n\n.db-page--luxury .pd-segment {\n  background: #f1f5f9;\n  border-radius: 10px;\n  padding: 3px;\n}\n\n.db-page--luxury .pd-segment__btn {\n  padding: 5px 12px;\n  font-size: 12px;\n  border-radius: 8px;\n}\n\n.db-page--luxury .pd-cashflow__row {\n  padding: 10px 0;\n  font-size: 13px;\n}\n\n.db-page--luxury .pd-inv-summary__row {\n  padding: 9px 0;\n  font-size: 13px;\n}\n\n.db-page--luxury .pd-table .ant-table-thead > tr > th {\n  font-size: 10px !important;\n  letter-spacing: 0.06em;\n  padding: 10px 12px !important;\n}\n\n.db-page--luxury .pd-table .ant-table-tbody > tr > td {\n  padding: 11px 12px !important;\n  font-size: 13px;\n}\n\n.db-page--luxury .pd-timeline__title {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.db-page--luxury .pd-rank-list__item {\n  padding: 10px 0;\n}\n\n.db-page--luxury .pd-quick-bar__btn {\n  padding: 9px 18px;\n  border-radius: var(--db-radius-sm);\n  font-size: 13px;\n  letter-spacing: -0.01em;\n}\n\n.db-page--luxury .db-lower-side .pd-card {\n  flex: 1;\n}\n\n.db-page--luxury .pd-kpi--clickable {\n  cursor: pointer;\n}\n\n.db-page--luxury .pd-kpi--clickable:hover {\n  border-color: rgba(37, 99, 235, 0.25);\n}\n\n.db-status--warn { color: #d97706; }\n.db-status--bad { color: #dc2626; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
